import { render, staticRenderFns } from "./DMWrap.vue?vue&type=template&id=456ab352&scoped=true&"
import script from "./DMWrap.vue?vue&type=script&lang=js&"
export * from "./DMWrap.vue?vue&type=script&lang=js&"
import style0 from "./DMWrap.vue?vue&type=style&index=0&id=456ab352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456ab352",
  null
  
)

export default component.exports